const CONTENT_TYPE = 'Content-Type';
const AUTHORIZATION = 'Authorization';
const CHANNEL = 'X-Channel';
const BRAND = 'X-Brand';
const LANGUAGE = 'X-Lang';
const OPERATOR_ID = 'X-Operator-Id';

export const HTTP_HEADERS = {
  CONTENT_TYPE,
  AUTHORIZATION,
  CHANNEL,
  BRAND,
  LANGUAGE,
  OPERATOR_ID,
};

export const EVA_API_SERVICE_NAME = 'live-casino';

export const FEATURE_CONFIG_URL = '/feature-flags';
export const COMMON_CONFIG_URL = '/config/common';

export const QUERY_KEY_BONUSES = 'bonuses';
export const QUERY_KEY_BONUS_HISTORY = 'bonus-history';
export const QUERY_KEY_BONUS_CONTENT = 'bonus-content';
export const QUERY_KEY_COLLECTING_GAMES = 'collecting-games';
export const QUERY_KEY_WAGERING_GAMES = 'wagering-games';
export const QUERY_KEY_GAME_INFO = 'game-info';
export const QUERY_KEY_GAMES_BY_IDS = 'games-by-ids';

export const QUERY_KEY_GAME = 'game';
export const QUERY_KEY_GAMES = 'games-list';
export const QUERY_KEY_INFINITY_GAMES = 'infinity-games';

export const ENTITIES_SORTING_CONFIG_URL = '/config/entities-sorting';
export const GEO_LOCATION_URL = '/api/geo-location';
